import React, { useRef } from "react";
import { motion } from "framer-motion";
import MagicParticles from "../index/MagicParticles";
import Header from "../index/Header";
//import SimpleBar from 'simplebar-react';
//import 'simplebar-react/dist/simplebar.min.css';
import Footer from "../index/Footer";


export default function CustomEvents() {
    function Card({ item, index }) {
        return (
            <motion.div
                className="bg-eryndra-ivory/10 backdrop-blur-md rounded-2xl border border-eryndra-gold p-8 shadow-lg"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2, duration: 0.6 }}
                viewport={{ once: true }}
            >
                <h3 className="text-2xl text-eryndra-gold font-simplicite mb-2">{item.title}</h3>
                <p className="font-bellefair text-lg">{item.description}</p>
            </motion.div>
        );
    }
    const scrollRef = useRef();
    const cards = [
        {
            title: "Bodas de Fantasía",
            description:
                "Creamos bodas inspiradas en cuentos de hadas, libros, mundos mágicos o tus propias fantasías. Desde los votos en un bosque encantado hasta recepciones con ambientación de reinos perdidos. Tú sueñas, nosotras lo diseñamos.",
            image: "/img/boda.jpg",
        },

        {
            title: "Cumpleaños temáticos",
            description:
                "Convierte tu día en una historia épica. Desde castillos medievales hasta bosques de hadas, diseñamos fiestas donde tú eres protagonista.",
            image: "/img/vela.jpg",
        },
        {
            title: "Pedidas de mano mágicas",
            description:
                "Creamos escenarios encantados para ese momento tan especial. Luces, música, decoración y detalles a medida que te harán suspirar.",
            image: "/img/anillos.jpg",
        },
        {
            title: "Aniversarios inolvidables",
            description:
                "Celebra vuestro amor con un evento íntimo lleno de símbolos, recuerdos y sorpresas, adaptado totalmente a vuestra historia.",
            image: "/img/aniversario.jpg",
        },
        {
            title: "Baby Showers encantados",
            description:
                "Dale la bienvenida al nuevo miembro de la familia con una celebración mágica, con decoraciones inspiradas en cuentos y mundos fantásticos.",
            image: "/img/baby2.jpg",
        },
        {
            title: "Eventos familiares",
            description:
                "Desde reuniones familiares hasta cenas especiales, diseñamos atmósferas cálidas y diferentes que harán que todos quieran repetir.",
            image: "/img/party.jpg",
        },
        {
            title: "Propuestas únicas",
            description:
                "¿Tienes una idea loca, divertida o soñadora? Nosotras le damos forma, color y emoción. ¡Cuéntanoslo y lo haremos posible!",
            image: "/img/globos.jpg",
        },
    ];

    return (
       // <SimpleBar ref={scrollRef} style={{ maxHeight: '100vh' }} autoHide={false}>
       <main className="font-cinzel bg-eryndra-forest text-eryndra-cream relative z-10">
            {/* <div className="relative bg-eryndra-forest text-eryndra-cream min-h-screen font-cinzel"> */}
                <div className="absolute inset-0 z-10 pointer-events-none">
                    <MagicParticles />
                </div>

                <Header scrollRef={scrollRef} backgroundColor="bg-eryndra-forest/20" />

                <motion.section className="relative bg-eryndra-flores bg-cover bg-center text-center py-80"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}>
                    <h1 className="font-title text-4xl md:text-6xl lg:text-8xl mb-4  tracking-widest text-shadow-md">CelebRAcioneS A MedidA</h1>
                    <p className="text-lg md:text-2xl  text-shadow-DEFAULT">
                        Tu historia merece ser inolvidable.
                    </p>
                </motion.section>
                
                <section className="relative py-20 px-6 bg-eryndra-forest text-eryndra-cream overflow-hidden">    

                    {/* Contenido */}
                    <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
                        {/* Imagen estilo recorte */}
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                            className="relative max-w-md shadow-lg rotate-[-2deg]"
                        >
                            <img
                                src="/img/boda.jpg"
                                alt="Bodas con magia"
                                loading="lazy"
                                className="rounded-xl border-[6px] border-eryndra-gold"
                            />

                        </motion.div>

                        {/* Texto con efecto recorte */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1 }}
                            className="max-w-xl text-left"
                        >
                            <h2 className="text-4xl md:text-5xl font-cinzel text-eryndra-gold mb-4">
                                Bodas de Fantasía
                            </h2>
                            <p className="font-bellefair text-2xl text-justify leading-relaxed mb-6">
                                Creamos bodas inspiradas en cuentos de hadas, libros, mundos mágicos o tus propias fantasías.
                                Desde los votos en un bosque encantado hasta recepciones con ambientación de reinos perdidos.
                                Tú sueñas, nosotras lo diseñamos.
                            </p>
                            
                        </motion.div>
                    </div>
                </section>
               {/*  <motion.section className="relative h-[500px] bg-cover bg-center bg-eryndra-pastel" 
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 1 }}>
                    <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(91,40,56,0.8)_0%,_rgba(91,40,56,0.6)_50%,_transparent_100%)] flex items-center ">
                        <div className="px-10 max-w-xl m-auto text-center">
                        <h3 className="text-4xl md:text-5xl text-eryndra-gold font-cinxel mb-2">Cumpleaños temáticos</h3>
                        <p className="text-eryndra-cream font-bellefair  text-2xl">Convierte tu día en una historia épica. Desde castillos medievales hasta bosques de hadas, diseñamos fiestas donde tú eres protagonista.</p>
                        </div>
                    </div>
                </motion.section> */}
                {/* <section className="relative py-20 px-6 bg-eryndra-forest text-eryndra-cream overflow-hidden">    

                    
                    <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
                        

                        
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1 }}
                            className="max-w-xl text-right "
                        >
                            <h2 className="text-4xl md:text-5xl font-cinzel text-eryndra-gold mb-4">
                            Pedidas de mano mágicas
                            </h2>
                            <p className="font-bellefair text-2xl  leading-relaxed mb-6">
                            Creamos escenarios encantados para ese momento tan especial. Luces, música, decoración y detalles a medida que te harán suspirar.
                            </p>
                            
                        </motion.div>

                        
                        <motion.div
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                            className="relative max-w-md shadow-lg rotate-[-2deg]"
                        >
                            <img
                                src="/img/anillos.jpg"
                                alt="Bodas con magia"
                                loading="lazy"
                                className="rounded-xl border-[6px] border-eryndra-gold"
                            />

                        </motion.div>
                    </div>
                </section> */}

                {/* <motion.section className="relative h-[500px] bg-cover bg-center bg-eryndra-aniversario " 
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 1 }}>
                    <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(91,40,56,0.8)_0%,_rgba(91,40,56,0.6)_50%,_transparent_100%)] flex items-center ">
                    <div className="px-10 max-w-xl m-auto text-center">
                        <h3 className="text-4xl md:text-5xl text-eryndra-gold  font-cinxel mb-2">Aniversarios inolvidables</h3>
                        <p className="text-eryndra-cream font-bellefair text-2xl">Celebra vuestro amor con un evento íntimo lleno de símbolos, recuerdos y sorpresas, adaptado totalmente a vuestra historia.</p>
                        </div>
                    </div>
                </motion.section> */}
                {/* <section className="relative py-20 px-6 bg-eryndra-forest text-eryndra-cream overflow-hidden">    

                    
                    <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
                        
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                            className="relative max-w-md shadow-lg rotate-[-2deg]"
                        >
                            <img
                                src="/img/baby2.jpg"
                                loading="lazy"
                                alt="Baby Showers encantados"
                                className="rounded-xl border-[6px] border-eryndra-gold"
                            />

                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1 }}
                            className="max-w-xl text-left"
                        >
                            <h2 className="text-4xl md:text-5xl font-cinzel text-eryndra-gold mb-4">
                            Baby Showers encantados
                            </h2>
                            <p className="font-bellefair text-2xl text-justify leading-relaxed mb-6">
                            Dale la bienvenida al nuevo miembro de la familia con una celebración mágica, con decoraciones inspiradas en cuentos y mundos fantásticos.
                            </p>
                            
                        </motion.div>
                    </div>
                </section> */}

                <motion.section className="relative h-[500px] bg-cover bg-center bg-eryndra-party " 
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 1 }}>
                    <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(91,40,56,0.8)_0%,_rgba(91,40,56,0.6)_50%,_transparent_100%)] flex items-center ">
                    <div className="max-w-xl m-auto text-center">
                        <h3 className="text-4xl md:text-5xl text-eryndra-gold  font-cinxel mb-2">Eventos Personalizados</h3>
                        <p className="text-eryndra-cream font-bellefair text-2xl">Desde reuniones familiares hasta cenas especiales, diseñamos atmósferas cálidas y diferentes que harán que todos quieran repetir.</p>
                        </div>
                    </div>
                </motion.section>

                <section className="relative py-20 px-6 bg-eryndra-forest text-eryndra-cream overflow-hidden">    

                    {/* Contenido */}
                    <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
                       
                        

                        {/* Texto con efecto recorte */}
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1 }}
                            className="max-w-xl text-right"
                        >
                            <h2 className="text-4xl md:text-5xl font-cinzel text-eryndra-gold mb-4">
                            Propuestas únicas
                            </h2>
                            <p className="font-bellefair text-2xl leading-relaxed mb-6">
                            ¿Tienes una idea loca, divertida o soñadora? Nosotras le damos forma, color y emoción. ¡Cuéntanoslo y lo haremos posible!
                            </p>
                            <div className="mt-4">
                        <a href="/contactanos" className="btn-eryndra-gold">
                            Cuéntanos tu idea
                        </a>
                    </div>
                            
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                            className="relative max-w-md shadow-lg rotate-[-2deg]"
                        >
                            <img
                                src="/img/globos.jpg"
                                loading="lazy"
                                alt="Propuestas únicas"
                                className="rounded-xl border-[6px] border-eryndra-gold"
                            />

                        </motion.div>
                        
                    </div>
                </section>




                
                <Footer />
            {/* </div> */}
            </main>
      //  </SimpleBar>
      
    );
}

